import { Container } from '@hover/blueprint';
import React, { useState } from 'react';
import { Layout } from '../../../v2/components/common';
import {
  CareersHero,
  CareersFloatingLinks,
  CareersHeaderDescription,
  CareersOurValues,
  CareersOurPeople,
  CareersOurTools,
  CareerOpenJobs,
  CareersFAQ,
  CareersContactUs,
} from '../../../v2/components/careers';

const anchorList = [
  {
    label: 'Our Values',
    to: '#careers-our-values',
  },
  {
    label: 'Our People',
    to: '#careers-our-people',
  },
  {
    label: 'Our Tools',
    to: '#our-tools',
  },
  {
    label: 'Open Roles',
    to: '#open-roles',
  },
  {
    label: 'FAQ',
    to: '#faq',
  },
];

const Careers: React.FC = () => {
  const [currentSection, setCurrentSection] = useState<string>('Our Values');

  return (
    <Layout
      title="Job Opportunities"
      description="HOVER is building the future of 3D property data. We are a small team that works hard and loves to celebrate our wins."
      additionalMetadata={[
        {
          property: 'og:image',
          content: '../../../images/LinkedIn-Open-Graph-photo.webp',
        },
        {
          name: 'twitter:image',
          content: '../../../images/LinkedIn-Open-Graph-photo.webp',
        },
        { property: 'og:image:width', content: '972' },
        { property: 'og:image:height', content: '512' },
      ]}
      isNavbarWhite={false}
      navbarBackgroundColor="brandNavy.500"
    >
      <CareersHero />
      <Container
        maxW="100%"
        position="relative"
        overflow="visible"
        alignItems="center"
        px={0}
      >
        <CareersFloatingLinks
          links={anchorList}
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
        />
        <CareersHeaderDescription setCurrentSection={setCurrentSection} />
        <CareersOurValues setCurrentSection={setCurrentSection} />
        <CareersOurPeople setCurrentSection={setCurrentSection} />
        <CareersOurTools setCurrentSection={setCurrentSection} />
        <CareerOpenJobs setCurrentSection={setCurrentSection} />
        <CareersFAQ setCurrentSection={setCurrentSection} />
      </Container>
      <CareersContactUs />
    </Layout>
  );
};

export default Careers;
